import image from "./Image.png";
import image1 from "./Image1.png";
import image2 from "./Image2.png";
import image3 from "./Image3.png";
import image4 from "./Image4.png";

export const WeHaveMoreImageData = [
  {
    id: "1",
    imageSrc: image,
  },
  {
    id: "2",
    imageSrc: image1,
  },
  {
    id: "3",
    imageSrc: image2,
  },
  {
    id: "4",
    imageSrc: image3,
  },
  {
    id: "5",
    imageSrc: image4,
  },
];
